export const SET_BUSY = '[mutations] set busy';
export const GET_BUSY = '[getters] get busy';
export const IS_USER_AUTHENTICATED = '[getters] is user authenticated';